import * as React from 'react'
import type { SVGProps } from 'react'
export interface PlusIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * plus
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const PlusIcon = (props: PlusIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 5v14m-7-7h14"
      />
    </svg>
  )
}
